<app-header></app-header>

@if (!loadingE) {

  <div class="container">
    <!-- HEADER -->
    <div class="header-container">
      @if (canalData && canalData.logo) {
        <div class="icon">
          <img
            [src]="canalData.logo"
            alt="Icono"
          />
        </div>
      }
      <div class="title-container">
        <h1>
          Organigrama {{ canalData?.name }}
        </h1>
      </div>

      <div class="button-container">
        <button
          (click)="goBack()"
          class="button-group"
        >
          ATRAS
        </button>
      </div>
    </div>
    <!-- ÁRBOL -->
    <div
      class="
        mt-[150px]
        w-[80%]
        rounded-md
        border
        p-4
      "
    >
      @if (equiposArbol.length > 0) {
        <div class="flex w-full flex-col gap-1">
          @for (
            node of equiposArbol;
            track $index
          ) {
            <!-- ================================= -->
            <!-- CANAL / SUBCANAL -->
            <!-- ================================= -->
            <hlm-collapsible class="w-full">
              <button
                hlmCollapsibleTrigger
                hlmBtn
                variant="ghost"
                size="sm"
                class="
                  group
                  w-full
                  justify-start
                  gap-2
                  text-left
                  transition-none
                  hover:bg-accent
                  hover:text-accent-foreground
                "
              >
                <!-- FLECHA -->
                <i
                  class="
                    fas
                    fa-chevron-right
                    w-4
                    transition-transform
                    group-data-[state=open]:rotate-90
                  "
                ></i>
                <!-- ICONO CANAL -->
                <i
                  [class]="node.icon"
                  class="w-5"
                ></i>
                <!-- TEXTO -->
                <span>
                  {{ node.label }}
                </span>

              </button>
              <!-- CONTENIDO CANAL/SUBCANAL -->
              <hlm-collapsible-content
                class="
                  mt-1
                  ml-5
                  flex
                  flex-col
                  gap-1
                "
              >
                @for (
                  equipo of node.children ?? [];
                  track $index
                ) {
                  <!-- ================================= -->
                  <!-- EQUIPO -->
                  <!-- ================================= -->
                  <hlm-collapsible class="w-full">
                    <button
                      hlmCollapsibleTrigger
                      hlmBtn
                      variant="ghost"
                      size="sm"
                      class="
                        group
                        w-full
                        justify-start
                        gap-2
                        text-left
                        transition-none
                        hover:bg-accent
                        hover:text-accent-foreground
                      "
                    >
                      <!-- FLECHA -->
                      <i
                        class="
                          fas
                          fa-chevron-right
                          w-4
                          transition-transform
                          group-data-[state=open]:rotate-90
                        "
                      ></i>
                      <!-- ICONO EQUIPO -->
                      <i
                        [class]="equipo.icon"
                        class="w-5"
                      ></i>
                      <!-- NOMBRE EQUIPO -->
                      <span>
                        {{ equipo.label }}
                      </span>
                    </button>
                    <!-- CONTENIDO EQUIPO -->
                    <hlm-collapsible-content
                      class="
                        mt-1
                        ml-5
                        flex
                        flex-col
                        gap-1
                      "
                    >
                      @for (
                        miembro of equipo.children ?? [];
                        track $index
                      ) {
                        <!-- ================================= -->
                        <!-- COORDINADOR / USUARIO -->
                        <!-- ================================= -->
                        <button
                          hlmBtn
                          variant="link"
                          size="sm"
                          class="
                            w-full
                            justify-start
                            gap-2
                            text-foreground
                          "
                        >
                          <!-- ICONO -->
                          <i
                            [class]="miembro.icon"
                            class="w-5"
                          ></i>
                          <!-- TEXTO -->
                          <span>
                            {{ miembro.label }}
                          </span>
                        </button>
                      }
                    </hlm-collapsible-content>
                  </hlm-collapsible>
                }
              </hlm-collapsible-content>
            </hlm-collapsible>
          }
        </div>
      } @else {
        <!-- SIN RESULTADOS -->
        <div
          class="
            flex
            items-center
            gap-2
            p-4
            text-sm
            text-muted-foreground
          "
        >
          <i class="fas fa-exclamation-circle"></i>
          <span>
            No hay equipos disponibles
          </span>
        </div>
      }
    </div>
  </div>
} @else {
  <!-- LOADING -->
  <div
    class="
      flex
      min-h-screen
      w-full
      items-center
      justify-center
    "
  >
    <div
      class="spinner-container flex flex-col items-center gap-3"
    >
      <mat-spinner></mat-spinner>
      <p class="m-0">
        Cargando...
      </p>
    </div>
  </div>
}

